var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useEffect, useContext, useMemo, useCallback } from "react";
import { Outlet, ScrollRestoration, useLocation, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Footer, Header, PageBanner } from "@sequentech/ui-essentials";
import { ELanguageDetectionPolicy, EVotingPortalCountdownPolicy, USER_LANGUAGE_COOKIE_NAME, setCookie, getValueFromCookie, } from "@sequentech/ui-core";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./providers/AuthContextProvider";
import { SettingsContext } from "./providers/SettingsContextProvider";
import { ApolloWrapper } from "./providers/ApolloContextProvider";
import { VotingPortalError, VotingPortalErrorType } from "./services/VotingPortalError";
import { useAppSelector } from "./store/hooks";
import { selectElectionIds } from "./store/elections/electionsSlice";
import { selectBallotStyleByElectionId, selectBallotStyleElectionIds, selectFirstBallotStyle, } from "./store/ballotStyles/ballotStylesSlice";
import { selectElectionEventById } from "./store/electionEvents/electionEventsSlice";
import WatermarkBackground from "./components/WaterMark/Watermark";
import SequentLogo from "@sequentech/ui-essentials/public/Sequent_logo.svg";
import BlankLogoImg from "@sequentech/ui-essentials/public/blank_logo.svg";
import { useElectionClassName } from "./hooks/useElectionClassName";
var StyledApp = styled(Stack)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-height: 100vh;\n\n    /* Visually hidden until focused, then shown for keyboard users */\n    .skip-link {\n        position: absolute;\n        top: -40px;\n        left: 0;\n        background: #fff;\n        color: #000;\n        padding: 8px 12px;\n        z-index: 1000;\n        text-decoration: none;\n    }\n    .skip-link:focus {\n        top: 0;\n    }\n"], ["\n    min-height: 100vh;\n\n    /* Visually hidden until focused, then shown for keyboard users */\n    .skip-link {\n        position: absolute;\n        top: -40px;\n        left: 0;\n        background: #fff;\n        color: #000;\n        padding: 8px 12px;\n        z-index: 1000;\n        text-decoration: none;\n    }\n    .skip-link:focus {\n        top: 0;\n    }\n"])));
var StyledAppWrapper = styled(Stack)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var css = _a.css;
    return css;
});
var StyledMain = styled("main")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: auto;\n    display: flex;\n    position: relative;\n    flex: 1;\n"], ["\n    margin-bottom: auto;\n    display: flex;\n    position: relative;\n    flex: 1;\n"])));
var HeaderWithContext = function () {
    var _a, _b, _c, _d, _e, _f;
    var authContext = useContext(AuthContext);
    var globalSettings = useContext(SettingsContext).globalSettings;
    var eventId = useParams().eventId;
    var ballotStyle = useAppSelector(selectFirstBallotStyle);
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var presentation = (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) !== null && _a !== void 0 ? _a : electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) !== null && _b !== void 0 ? _b : undefined;
    var languagesList = (_d = (_c = presentation === null || presentation === void 0 ? void 0 : presentation.language_conf) === null || _c === void 0 ? void 0 : _c.enabled_language_codes) !== null && _d !== void 0 ? _d : ["en"];
    var showUserProfile = (_e = presentation === null || presentation === void 0 ? void 0 : presentation.show_user_profile) !== null && _e !== void 0 ? _e : true;
    var countdownPolicy = useMemo(function () {
        return presentation === null || presentation === void 0 ? void 0 : presentation.voting_portal_countdown_policy;
    }, [presentation]);
    var logoImg = (presentation === null || presentation === void 0 ? void 0 : presentation.logo_url) === undefined
        ? BlankLogoImg
        : (presentation === null || presentation === void 0 ? void 0 : presentation.logo_url) === null
            ? SequentLogo
            : presentation === null || presentation === void 0 ? void 0 : presentation.logo_url;
    var onChangeLanguage = function (lang) {
        if (getValueFromCookie(USER_LANGUAGE_COOKIE_NAME) !== lang) {
            setCookie(USER_LANGUAGE_COOKIE_NAME, lang);
        }
    };
    return (_jsx(Header, { appVersion: { main: globalSettings.APP_VERSION }, appHash: { main: globalSettings.APP_HASH }, userProfile: {
            firstName: authContext.firstName,
            username: authContext.username,
            email: authContext.email,
            openLink: showUserProfile ? authContext.openProfileLink : undefined,
        }, languagesList: languagesList, logoutFn: authContext.isAuthenticated ? authContext.logout : undefined, logoUrl: logoImg, expiry: {
            alertAt: countdownPolicy === null || countdownPolicy === void 0 ? void 0 : countdownPolicy.countdown_alert_anticipation_secs,
            countdown: (_f = countdownPolicy === null || countdownPolicy === void 0 ? void 0 : countdownPolicy.policy) !== null && _f !== void 0 ? _f : EVotingPortalCountdownPolicy.NO_COUNTDOWN,
            countdownAt: countdownPolicy === null || countdownPolicy === void 0 ? void 0 : countdownPolicy.countdown_anticipation_secs,
            endTime: authContext.getExpiry(),
            duration: countdownPolicy === null || countdownPolicy === void 0 ? void 0 : countdownPolicy.countdown_anticipation_secs,
        }, onChangeLanguage: onChangeLanguage }));
};
var App = function () {
    var _a, _b;
    var navigate = useNavigate();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var location = useLocation();
    var _c = useParams(), tenantId = _c.tenantId, eventId = _c.eventId;
    var _d = useContext(AuthContext), isAuthenticated = _d.isAuthenticated, setTenantEvent = _d.setTenantEvent;
    var electionIds = useAppSelector(selectElectionIds);
    var ballotStyleElectionIds = useAppSelector(selectBallotStyleElectionIds);
    var ballotStyle = useAppSelector(function (state) {
        var _a;
        var electionId = (_a = electionIds[0]) !== null && _a !== void 0 ? _a : ballotStyleElectionIds[0];
        return electionId ? selectBallotStyleByElectionId(String(electionId))(state) : undefined;
    });
    useElectionClassName();
    useEffect(function () {
        if (location.pathname === "/") {
            throw new VotingPortalError(VotingPortalErrorType.NO_ELECTION_EVENT);
        }
    }, [
        globalSettings.DEFAULT_TENANT_ID,
        globalSettings.DEFAULT_EVENT_ID,
        globalSettings.DISABLE_AUTH,
        navigate,
        location.pathname,
    ]);
    var electionEventConfigUrl = "".concat(globalSettings.PUBLIC_BUCKET_URL, "tenant-").concat(tenantId, "/event-").concat(eventId, "/election_event_config.json");
    // Set up tenant and event in AuthContext on initial load.
    // It is needed to fetch the election event config file from S3
    // and apply the language policy before loading any other data.
    var setupTenantEvent = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var isRegisterFlow, mode, response, config, presentation, languageConf, defaultLocale, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!tenantId || !eventId) {
                        return [2 /*return*/];
                    }
                    isRegisterFlow = location.pathname.includes("/enroll");
                    mode = isRegisterFlow ? "register" : "login";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(electionEventConfigUrl)];
                case 2:
                    response = _a.sent();
                    if (!response.ok) {
                        throw new Error("HTTP ".concat(response.status));
                    }
                    return [4 /*yield*/, response.json()];
                case 3:
                    config = (_a.sent());
                    presentation = config.election_event_presentation;
                    languageConf = presentation === null || presentation === void 0 ? void 0 : presentation.language_conf;
                    defaultLocale = (languageConf === null || languageConf === void 0 ? void 0 : languageConf.language_detection_policy) === ELanguageDetectionPolicy.FORCE_DEFAULT
                        ? languageConf.default_language_code
                        : undefined;
                    setTenantEvent(tenantId, eventId, mode, defaultLocale);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error("Error loading election event config:", error_1);
                    setTenantEvent(tenantId, eventId, mode, undefined);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [tenantId, eventId, electionEventConfigUrl, location.pathname, setTenantEvent]);
    useEffect(function () {
        if (isAuthenticated) {
            return;
        }
        var isDemo = sessionStorage.getItem("isDemo");
        if (!globalSettings.DISABLE_AUTH && isDemo) {
            var areaId = sessionStorage.getItem("areaId");
            var documentId = sessionStorage.getItem("documentId");
            var publicationId = sessionStorage.getItem("publicationId");
            navigate("/preview/".concat(tenantId, "/").concat(documentId, "/").concat(areaId, "/").concat(publicationId));
            window.location.reload();
            return;
        }
        void setupTenantEvent();
    }, [isAuthenticated, globalSettings.DISABLE_AUTH, navigate, tenantId, setupTenantEvent]);
    return (_jsx(StyledAppWrapper, { css: (_b = (_a = ballotStyle === null || ballotStyle === void 0 ? void 0 : ballotStyle.ballot_eml.election_event_presentation) === null || _a === void 0 ? void 0 : _a.css) !== null && _b !== void 0 ? _b : "", children: _jsxs(StyledApp, { className: "app-root", children: [_jsx(ScrollRestoration, {}), _jsxs(ApolloWrapper, { children: [_jsx(HeaderWithContext, {}), _jsxs(PageBanner, { marginBottom: "auto", sx: { display: "flex", position: "relative", flex: 1 }, className: "main", component: "main", id: "main-content", role: "main", children: [_jsx(WatermarkBackground, {}), _jsx(Outlet, {})] })] }), _jsx(Footer, {})] }) }));
};
export default App;
var templateObject_1, templateObject_2, templateObject_3;
